export const LAYOUT_TYPE = {
  flow: 'flow',
  position: 'position'
};

export const AWARD_ERR_CODE = {
  SUCCESS: 0,
  UNDERSTOCK: 1, // 奖品无库存
  TIMEOUT: 2 // 上游服务超时
};

// 奖励页 tab reward type
export const TAB_REWARD_TYPE = {
  AWARDS: 1,
  CASH_PACK: 2
};

export const AWARD_NAME = {
  MEMBER: '权益卡',
  OIL_COUPON: '加油卡',
  RIGHT_CARD: '权益卡',
  ENTITY: '实物奖'
};

// 业务券类型：1-通用券，2-搬家券，3-大货车券，4-小B货运券，5-零担物流，6-司机会员优惠券
export const COUPON_NAME = {
  1: '通用券',
  2: '搬家券',
  3: '大货车券',
  4: '货运券',
  5: '零担物流券',
  6: '司机会员优惠券'
};

// PASSPORT(0)抽奖机会，COUPON(4)券，RED_PACKET(2)红包，VIRTUAL_CURRENCY(3)奖励金
// CURRENCY(5)现金，ENTITY(1)实物，MEMBER(7)会员，OIL_COUPON(6)加油卡，NULL(-1)无奖励
export const AWARD_TYPE_ID_MAP = {
  0: 'PASSPORT',
  1: 'ENTITY',
  2: 'RED_PACKET',
  3: 'VIRTUAL_CURRENCY',
  4: 'COUPON',
  5: 'CURRENCY',
  6: 'OIL_COUPON',
  7: 'MEMBER',
  '-1': 'NULL'
};
